module.exports = __webpack_public_path__ + "static/media/telerama-logo.6efcd9df.jpg";